import { render, staticRenderFns } from "./portfolio-stat-card.vue?vue&type=template&id=73c706f0&scoped=true"
import script from "./portfolio-stat-card.ts?vue&type=script&lang=ts&external"
export * from "./portfolio-stat-card.ts?vue&type=script&lang=ts&external"
import style0 from "./portfolio-stat-card.scss?vue&type=style&index=0&id=73c706f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c706f0",
  null
  
)

export default component.exports